'use client'

import React, { HTMLAttributes, ReactNode, useEffect, useState } from 'react'
import { headline, HeadlineVariants } from './Headline.css'
import { AppTitle } from '../AppTitle'
import { LogoHead } from '@otomoro/components/icons'

interface HeadlineProps extends HTMLAttributes<Element>, HeadlineVariants {
	headlineText?: string
	subheadline?: string
	theme?: 'light' | 'dark' | 'pink'
	border?: boolean
	size?: 'normal' | 'large'
	children?: ReactNode | ReactNode[]
	healineSize?: string
	headlineSVG?: {
		svg?: string
	}
	type?: string
}

function adjustFontSize() {
	const mainTitle = document.getElementById('pageTitle')
	const container = mainTitle?.parentElement
	if (!mainTitle || !container) return

	let mainTitleFontSize = 1
	mainTitle.style.fontSize = mainTitleFontSize + 'px'

	while (mainTitle.offsetWidth < container.offsetWidth) {
		mainTitleFontSize++
		mainTitle.style.fontSize = mainTitleFontSize + 'px'
	}

	mainTitle.style.fontSize = mainTitleFontSize - 1 + 'px'
	mainTitle.style.lineHeight = mainTitleFontSize - 1 + 'px'
}

export const Headline: React.FC<HeadlineProps> = ({
	theme = 'light',
	border,
	headlineText,
	subheadline,
	headlineSVG,
}) => {
	const { base } = headline({ theme })
	// HACK: the isLoaded is necessary to avoid the user to see the resize happening on a reload
	// it'll adjust the opacity from 0->100%
	const [isLoaded, setIsLoaded] = useState(false)

	useEffect(() => {
		adjustFontSize()
		setIsLoaded(true)

		window.addEventListener('resize', adjustFontSize)
		return () => {
			window.removeEventListener('resize', adjustFontSize)
		}
	}, [])

	return (
		<header className={base({ theme, border })}>
			<div
				className="top-[15.6rem] lg:top-[18rem] left-1/2 -translate-x-1/2 absolute w-[10.27rem] lg:w-[16rem]"
				style={{ aspectRatio: 1 / 1 }}
			>
				<LogoHead className="w-full" />

				{headlineSVG?.svg ? (
					<span className="pt-2 block" dangerouslySetInnerHTML={{ __html: headlineSVG.svg }} />
				) : (
					<>
						<AppTitle
							id="pageTitle"
							as="strong"
							textAlign="left"
							textTransform="uppercase"
							className={`pt-1 inline-block ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity`}
							color="mainPink"
						>
							{headlineText}
						</AppTitle>
					</>
				)}
			</div>

			{subheadline && (
				<AppTitle
					as="h1"
					textAlign="left"
					textTransform="uppercase"
					color={theme === 'dark' ? 'white' : 'black'}
					className="!text-h3-mobile lg:!text-h2 pb-[1.5rem] lg:pb-2 absolute left-0 bottom-0"
				>
					{subheadline}
				</AppTitle>
			)}

			{/* <div className={content()}>{children}</div> */}
		</header>
	)
}
